import styled from "styled-components";
import {device, TYPE_DECOUPE, TYPE_PLIAGE} from "../../helper/constants";
import {DECOUPE_FORMS, MATERIAL_SHADES, PLIAGE_FORMS} from "../../helper/materials";
import {ConfigurateurContext} from "../../context/context";
import ProductQuantityButton from "../ProductQuantityButton";
import DXFPriceView from "./DXFPriceView";
import {DXFConfigurateurContext} from "../../context/dxfContext";
import SVGContainer from "../SVGContainer";
import {computeDXFWeight, computeWeight} from "../../helper/function";
import Devis from "../Devis";
const {
    element: {
        useContext,
    },
} = wp;
const Wrapper = styled.div`
    flex-basis: 100%;
    padding: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    font-size: 18px;
    font-weight: bold;
    color: #144344;
    @media ${device.mobile} {
        justify-content: space-evenly;
      flex-direction: column;
    }
`;

const WrapperDetailContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33%;
    @media ${device.mobile} {
        margin-top: 10px;
        width: 100%;
        justify-content: start;
        overflow: scroll;
        margin-bottom: 10px;
        padding-bottom: 70px !important;
    }
`;

const DetailContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
`;

const MaterialContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42%;
  gap: 10px;
  
  & span {
    font-size: 18px;
    font-weight: bold;
  }
`;

const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 33%;
    gap: 20px;
    @media ${device.mobile} {
        width: 100%;   
    }
`;
const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 46%;
  
    & img {
        border-radius: 0 !important;
    }
`;
const PriceViewContainer = styled.div`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    right: 0;
    display: flex;
    
    @media ${device.tablet} {
    
    }
    @media ${device.mobile} {
        padding: 10px;
        position: absolute;
        bottom: 80px;
        display: flex;
        flex-direction: row-reverse;
        background-color: #fff;
        align-items: center;
        justify-content: center;
        left: 8px;
        right: 8px;
    }
`;
const LargeurView = styled.div`
    margin-top: 20px;
`;
const SubView = styled.div`
    margin-top: 0;
`;
export default function CommandStepContainer({material, shade}) {

    const {thickness, quantity, setQuantity, width, height, svgFile, canAddToCart, setCanAddToCart} = useContext(DXFConfigurateurContext);

    const handleQuantityChange = (newQuantity) => {
        setQuantity(newQuantity);
    }

    const weight = computeDXFWeight(width, height, shade, thickness)

    if (weight > 55) {
        setCanAddToCart(false);
    }

    return (
        <Wrapper>
            {!canAddToCart ? (
                <Devis message="Merci de nous contacter via le formulaire de contact ou appelez nous pour un devis." />
            ) : (
                <>
                    <ImageContainer>
                        <IconContainer>
                            <SVGContainer
                                src={svgFile}
                                width={width}
                                height={height}
                            />
                        </IconContainer>
                        <MaterialContainer>
                            <img src={MATERIAL_SHADES[material][shade].image} alt={""} />
                            <span>{MATERIAL_SHADES[material][shade].fullLabel}</span>
                        </MaterialContainer>
                    </ImageContainer>
                    <WrapperDetailContainer>
                        <DetailContainer>
                            <SubView>
                                <div>{`Taille = ${width.toFixed(2)} x ${height.toFixed(2)} mm`}</div>
                                <div>{`Épaisseur = ${thickness} mm`}</div>
                                <div>{`Poids unité = ${computeDXFWeight(width, height, shade, thickness)} kg`}</div>
                                <div>{`Poids total = ${(computeDXFWeight(width, height, shade, thickness) * quantity).toFixed(2)} kg`}</div>
                            </SubView>

                        </DetailContainer>
                    </WrapperDetailContainer>
                    <PriceViewContainer>
                        <DXFPriceView />
                        <ProductQuantityButton quantity={quantity} handleChange={handleQuantityChange} />
                    </PriceViewContainer>
                </>
            )}
        </Wrapper>
    )
}